module.exports = __webpack_public_path__ + "static/media/Amrita_Logo.98f0a436.png";